import type {
  CardPreviewSlots as CardPreviewBaseSlots,
  CardPreviewBaseProps,
  CardPreviewBaseState,
} from '@fluentui/react-card';

/**
 * CardPreview component slots
 */
export type CardPreviewSlots = CardPreviewBaseSlots;

/**
 * CardPreview component props
 */
export type CardPreviewProps = CardPreviewBaseProps;

/**
 * CardPreview component state
 */
export type CardPreviewState = CardPreviewBaseState;
